import { NodeType, Node } from 'prosemirror-model'

export const findNodeByType = (doc: Node, nodeType: NodeType): Node | null => {
  let foundNode: Node | null = null

  function traverse(node: Node) {
    if (foundNode) return // Stop if node is already found

    // Check the current node
    if (node.type === nodeType) {
      foundNode = node
      return
    }

    // Traverse child nodes
    node.forEach(traverse)
  }

  traverse(doc)
  return foundNode
}
